import { render, staticRenderFns } from "./CommonDialog.vue?vue&type=template&id=12955a22"
import script from "./CommonDialog.vue?vue&type=script&lang=js"
export * from "./CommonDialog.vue?vue&type=script&lang=js"
import style0 from "./CommonDialog.vue?vue&type=style&index=0&id=12955a22&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports